import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconStackHorizontalAltFour24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconStackHorizontalAltFour24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5 12a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m1.5 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0m3 .5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m0 1.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4m5.5-2a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m1.5 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0m3.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m1.5 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconStackHorizontalAltFour24);
